<template>
  <div :style="{ '--default-height': height }" class="todo-edit-model">
    <Teleport v-if="visible && appendToBody" to="body">
      <div class="todo-edit" @click.stop="close" ref="todoEditModel">
        <div class="todo-edit-content" @click.stop :style="rect">
          <template v-if="isTextAndTextarea">
            <el-input @click.stop  ref="textInp"  class="todo-edit-inp"
              :type="column.type"
              @input="changeValue"
              @keydown.enter="enterCheck"
              @keydown.ctrl.enter="controlEnterCheck"
              :modelValue="getValue"
              :placeholder="column.type === 'textarea' ? 'Ctrl+Enter可换行' : column.placeholder" 
            />
          </template>
          <template v-else-if="isNumber">
            <el-input-number 
              @input="changeNumValue"
              style="width: 100%;" 
              :modelValue="getValue" 
              controls-position="right"
              class="todo-number todo-number-wy"
              ref="todoNumber"
              @click.stop
              :placeholder="column.placeholder"
              :min="Number(column.min)"
              :max="Number(column.max)"
            />
            {{ isWYFN(column) ? '万元' : '' }}
          </template>
          <template v-else-if="isCheckBox">
            <el-select 
              ref="todoSelect"
              :placeholder="column.placeholder" 
              clearable
              collapse-tags filterable multiple class="todo-select" 
              @change="changeValue" 
              v-if="column.types !== 4" 
              :modelValue="getValue">
                <el-option v-for="(sels, selsIndex) in objSels(column.sels)" :key="selsIndex" :label="sels" :value="sels" />
            </el-select>
          </template>
          <template v-else-if="isRadio">
            <el-select
              class="todo-select" 
              ref="todoSelect"
              filterable
              clearable
              @change="changeValue"
              v-if="column.types !== 4" 
              :modelValue="getValue"
              popper-style="zIndex:10000;"
            >
              <el-option v-for="(sels, selsIndex) in objSels(column.sels)" :key="selsIndex" :label="sels.label || sels" :value="sels.value || sels" />
            </el-select>
            <template v-else>
              <div class="radio-switch">
                <template v-if="column.switchStyle && column.switchStyle === 3">
                  {{ row[column.title] }}
                  <div :class="['radio-checkbox', row[column.title] === getSwitchColor({ele: column, type: 'active',isGet: true}) ? 'radio-checkbox-active' : '']" @click="upCheckbox({ val: row[val.title] === getSwitchColor({ele: column, type: 'active',isGet: true}) ? getSwitchColor({ele: column, type: 'inactive',isGet: true}) : getSwitchColor({ele: column, type: 'active',isGet: true}), item: column, row: row, title: column.title })">
                    <i class="iconfont el-icon-check" />
                  </div>
                </template>
                <el-switch v-else
                  :active-value="getSwitchColor({ele: column, type: 'active',isGet: true})"
                  :inactive-value="getSwitchColor({ele: column, type: 'inactive',isGet: true})"
                  :active-color="getSwitchColor({ele: column, type: 'active'})"
                  :inactive-color="getSwitchColor({ele: column, type: 'inactive'})"
                  :inactive-text="column.switchStyle === 1 ? '' : getSwitchColor({ele: column, type: 'inactive', isGet: true})"
                  :active-text="column.switchStyle === 1 ? '' : getSwitchColor({ele: column, type: 'active', isGet: true})"
                  :modelValue="getValue"
                  @change="changeValue"
                />
              </div>
            </template>
          </template>
          <template v-else-if="isDate">
            <el-date-picker
              v-if="column.match == 'yyyy-MM-dd' || column.match == 'yyyy-MM-dd ww'"
              :modelValue="getValue"
              type="date"
              class="todo-date"
              ref="todoDate"
              popper-style="zIndex:10000;"
              placeholder="选择日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              style="width: 100%;"
              @click.stop
              :default-value="nextMonthFun(column.limit || '')"
              @input="changeValue"
              :picker-options="pickerOptionsLimit(column)"
              :disabled="column.exhibiIs"
            ></el-date-picker>
            <el-time-picker
              v-else-if="column.match == 'HH:mm'"
              :modelValue="getValue"
              @change="changeValue"
              class="todo-date"
              ref="todoDate"
              popper-style="zIndex:10000;"
              value-format="HH:mm"
              @click.stop
              :picker-options="{ format: 'HH:mm' }"
              :disabled="column.exhibiIs"
              placeholder="任意时间点">
            </el-time-picker>
            <el-date-picker
              v-else
              :modelValue="getValue"
              class="todo-date"
              type="datetime"
              ref="todoDate"
              popper-style="zIndex:10000;"
              @click.stop
              placeholder="选择日期时间"
              style="width: 100%;"
              @input="changeValue"
              :picker-options="pickerOptionsLimit(column)"
              :default-value="nextMonthFun(column.limit || '')"
              format="YYYY-MM-DD HH:mm"
              value-format="YYYY-MM-DD HH:mm"
              :disabled="column.exhibiIs"
            ></el-date-picker>
          </template>
          <template v-else-if="isNewRelRadio">
            <newRelRadio
              class="todo-select"
              :bindVal="{[`${column.title}_${column.type}`]: row[column.title]}"
              :formdata="{[`${column.title}_${column.type}`]: row[column.title]}"
              :userHide="{}"
              :isMom="false"
              :isTodo="true"
              :approvalId="approvalId"
              @changeRefTodo="changeValue"
              :relRadio="column">
            </newRelRadio>
          </template>
          <template v-else-if="isOrgAndRole">
            <el-popover v-model:visible="isAppenPop" :width="rect.width" trigger="click" ref="popover" placement="bottom">
              <template v-slot:reference>
                <el-input @keydown="goSearchOrg" clearable ref="orgInput" v-model="seachText" v-if="column.type === 'organization'"></el-input>
                <el-input v-else :modelValue="getOrgShowName" readonly></el-input>
              </template>
              <div class="role-organize-content">
                <template v-if="column.type === 'roule'">
                  <role :isCheck="getOrgAndRoleConfig.onlyUser" ref="roleRef" @change-checked="changeCheck($event, 'role')" />
                </template>
                <template v-else-if="column.type === 'organization'">
                  <organize :maxCount="column.maxCount" :isCheck="getOrgAndRoleConfig.onlyUser" @change-checked="changeCheck($event, 'organization')" ref="organizeRef" />
                </template>
              </div>
            </el-popover>
          </template>
          <template v-else-if="isFile">
            <!-- 文件类型 -->
            <div class="img-file">
              <div v-for="(item2,idx2) in getValue" :key="idx2" class="img-file-style">
                <i class="iconfont icon-wenjianfujian"></i>
                <span type="primary" style="width: fit-content;" class="img-file-content">
                  {{ strImgAndFileData(item2) }}
                </span>
                <span type="primary" class="img-file-icon">
                  <i class="iconfont icon-xiazai2x"></i>
                </span>
                <i class="el-icon-delete" @click.stop="delUpload(idx2)" />
              </div>
              <div class="todo-upload" @click.stop>
                <el-upload
                  :action="$url +'/userfile/upload?accesstoken='+token"
                  :show-file-list="false"
                  :limit="Number(column.upNumber)"
                  :multiple="true"
                  :before-upload="beforeFileUpload"
                  :on-success="uploadSuccess">
                  <el-icon>
                    <Plus />
                  </el-icon>
                </el-upload>
              </div>
            </div>
          </template>
          <template v-else-if="isImage">
              <div class="list-app-img">
                <div @click.stop class="list-app-img-item" :key="imgIndex" v-for="(img, imgIndex) in getValue" >
                  <el-image
                    class="todo-img"
                    :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()"
                    :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"
                    fit="cover"
                  />
                  <div class="img-mask">
                    <i class="el-icon-delete" @click="delUpload(imgIndex)"></i>
                  </div>
                </div>
                <div class="todo-upload" @click.stop>
                  <el-upload
                    :action="$url+'/userfile/upload?accesstoken='+token"
                    :data="{accesstoken: token}"
                    :show-file-list="false"
                    :on-success="uploadSuccess"
                    :before-upload="beforeImgUpload">
                    <el-icon>
                      <Plus />
                    </el-icon>
                  </el-upload>
                </div>
              </div>
          </template>
        </div>
      </div>
    </Teleport>
    <div class="todo-edit-on" v-else-if="visible && !appendToBody" @click.stop style="height: 100%;display: flex;align-items: center;">
      <template v-if="isTextAndTextarea">
        <el-input @click.stop  ref="textInp"  class="todo-edit-inp"
          :type="column.type"
          @input="changeValue"
          @keydown.enter="enterCheck"
          @keydown.ctrl.enter="controlEnterCheck"
          :modelValue="getValue"
          :placeholder="column.type === 'textarea' ? 'Ctrl+Enter可换行' : column.placeholder" 
        />
      </template>
      <template v-else-if="isNumber">
        <el-input-number 
          @input="changeNumValue"
          style="width: 100%;" 
          :modelValue="getValue" 
          controls-position="right"
          class="todo-number todo-number-wy"
          ref="todoNumber"
          @click.stop
          :placeholder="column.placeholder"
          :min="Number(column.min)"
          :max="Number(column.max)"
        />
        {{ isWYFN(column) ? '万元' : '' }}
      </template>
      <template v-else-if="isCheckBox">
        <el-select 
          ref="todoSelect"
          :placeholder="column.placeholder" 
          clearable
          collapse-tags filterable multiple class="todo-select" 
          @change="changeValue" 
          v-if="column.types !== 4" 
          :modelValue="getValue">
            <el-option v-for="(sels, selsIndex) in objSels(column.sels)" :key="selsIndex" :label="sels" :value="sels" />
        </el-select>
      </template>
      <template v-else-if="isRadio">
        <el-select
          class="todo-select" 
          ref="todoSelect"
          filterable
          clearable
          @change="changeValue"
          v-if="column.types !== 4" 
          :modelValue="getValue"
        >
          <el-option v-for="(sels, selsIndex) in objSels(column.sels)" :key="selsIndex" :label="sels.label || sels" :value="sels.value || sels" />
        </el-select>
        <template v-else>
          <div class="radio-switch">
            <template v-if="column.switchStyle && column.switchStyle === 3">
              {{ row[column.title] }}
              <div :class="['radio-checkbox', row[column.title] === getSwitchColor({ele: column, type: 'active',isGet: true}) ? 'radio-checkbox-active' : '']" @click="upCheckbox({ val: row[val.title] === getSwitchColor({ele: column, type: 'active',isGet: true}) ? getSwitchColor({ele: column, type: 'inactive',isGet: true}) : getSwitchColor({ele: column, type: 'active',isGet: true}), item: column, row: row, title: column.title })">
                <i class="iconfont el-icon-check" />
              </div>
            </template>
            <el-switch v-else
              :active-value="getSwitchColor({ele: column, type: 'active',isGet: true})"
              :inactive-value="getSwitchColor({ele: column, type: 'inactive',isGet: true})"
              :active-color="getSwitchColor({ele: column, type: 'active'})"
              :inactive-color="getSwitchColor({ele: column, type: 'inactive'})"
              :inactive-text="column.switchStyle === 1 ? '' : getSwitchColor({ele: column, type: 'inactive', isGet: true})"
              :active-text="column.switchStyle === 1 ? '' : getSwitchColor({ele: column, type: 'active', isGet: true})"
              :modelValue="getValue"
              @change="changeValue"
            />
          </div>
        </template>
      </template>
      <template v-else-if="isDate">
        <el-date-picker
          v-if="column.match == 'yyyy-MM-dd' || column.match == 'yyyy-MM-dd ww'"
          :modelValue="getValue"
          type="date"
          class="todo-date"
          ref="todoDate"
          popper-style="zIndex:10000;"
          placeholder="选择日期"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          style="width: 100%;"
          @click.stop
          :default-value="nextMonthFun(column.limit || '')"
          @input="changeValue"
          :picker-options="pickerOptionsLimit(column)"
          :disabled="column.exhibiIs"
        ></el-date-picker>
        <el-time-picker
          v-else-if="column.match == 'HH:mm'"
          :modelValue="getValue"
          @change="changeValue"
          class="todo-date"
          ref="todoDate"
          popper-style="zIndex:10000;"
          value-format="HH:mm"
          @click.stop
          :picker-options="{ format: 'HH:mm' }"
          :disabled="column.exhibiIs"
          placeholder="任意时间点">
        </el-time-picker>
        <el-date-picker
          v-else
          :modelValue="getValue"
          class="todo-date"
          type="datetime"
          ref="todoDate"
          popper-style="zIndex:10000;"
          @click.stop
          placeholder="选择日期时间"
          style="width: 100%;"
          @input="changeValue"
          :picker-options="pickerOptionsLimit(column)"
          :default-value="nextMonthFun(column.limit || '')"
          format="YYYY-MM-DD HH:mm"
          value-format="YYYY-MM-DD HH:mm"
          :disabled="column.exhibiIs"
        ></el-date-picker>
      </template>
      <template v-else-if="isNewRelRadio">
        <newRelRadio
          class="todo-select"
          :bindVal="{[`${column.title}_${column.type}`]: row[column.title]}"
          :formdata="{[`${column.title}_${column.type}`]: row[column.title]}"
          :userHide="{}"
          :isMom="false"
          :isTodo="true"
          :approvalId="approvalId"
          @changeRefTodo="changeValue"
          :relRadio="column">
        </newRelRadio>
      </template>
      <template v-else-if="isOrgAndRole">
        <el-popover v-model:visible="isAppenPop" :width="rect.width" trigger="click" ref="popover" placement="bottom">
          <template v-slot:reference>
            <el-input @keydown="goSearchOrg" clearable v-model="seachText" v-if="column.type === 'organization'"></el-input>
            <el-input v-else :modelValue="getOrgShowName" readonly></el-input>
          </template>
          <div style="max-height: 400px; overflow-y: auto;min-height:20px;">
            <template v-if="column.type === 'roule'">
              <role :isCheck="getOrgAndRoleConfig.onlyUser" ref="roleRef" @change-checked="changeCheck($event, 'role')" />
            </template>
            <template v-else-if="column.type === 'organization'">
              <organize :maxCount="column.maxCount" :isCheck="getOrgAndRoleConfig.onlyUser" @change-checked="changeCheck($event, 'organization')" ref="organizeRef" />
            </template>
          </div>
        </el-popover>
      </template>
      <template v-else-if="isFile">
        <!-- 文件类型 -->
        <div class="img-file">
          <div v-for="(item2,idx2) in getValue" :key="idx2" class="img-file-style">
            <i class="iconfont icon-wenjianfujian"></i>
            <span type="primary" style="width: fit-content;" class="img-file-content">
              {{ strImgAndFileData(item2) }}
            </span>
            <span type="primary" class="img-file-icon">
              <i class="iconfont icon-xiazai2x"></i>
            </span>
            <i class="el-icon-delete" @click.stop="delUpload(idx2)" />
          </div>
          <div class="todo-upload" @click.stop>
            <el-upload
              :action="$url+'/userfile/upload?accesstoken='+token"
              :show-file-list="false"
              :limit="Number(column.upNumber)"
              :multiple="true"
              :before-upload="beforeFileUpload"
              :on-success="uploadSuccess">
                <el-icon>
                  <Plus />
                </el-icon>
            </el-upload>
          </div>
        </div>
      </template>
      <template v-else-if="isImage">
          <div class="list-app-img">
            <div @click.stop class="list-app-img-item" :key="imgIndex" v-for="(img, imgIndex) in getValue" >
              <el-image
                class="todo-img"
                :src="img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()"
                :preview-src-list="[img.url ? img.url : $imgurl + img.response + '?accesstoken=' + filesConfig()]"
                fit="cover"
              />
              <div class="img-mask">
                <i class="el-icon-delete" @click="delUpload(imgIndex)"></i>
              </div>
            </div>
            <div class="todo-upload" @click.stop>
              <el-upload
                :action="$url+'/userfile/upload?accesstoken='+token"
                :data="{accesstoken: token}"
                :show-file-list="false"
                :on-success="uploadSuccess"
                :before-upload="beforeImgUpload">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
      </template>
    </div>
  </div>
</template>

<script>
import { isObject, isEqual, cloneDeep } from 'lodash'
import { isWY, limitDate, thisNoTime, isJSON } from '@/api/utils'
import { getSwitchColor, filesConfig, getOrgShowName } from '@/api/global'
import newRelRadio from "@/components/clientSide//formFillinPageChild/newRelRadio.vue";
import role from '@/components/common/multipleChoice/role.vue'
import organize from '@/components/common/multipleChoice/organize.vue'
import { formatRole, formatOrg } from '../screen/utils/utils'
import { getUserParam } from '@/components/schoolInstrument/component/mutual/common/config.js'
export default {
  // 组件名称
  name: 'todoEdit',
  // 组件参数 接收来自父组件的数据
  props: {
    approvalId: {
      type: [String, Number],
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '32px'
    }
  },
  // 局部注册的组件
  components: {
    newRelRadio,
    role,
    organize
  },
  // 组件状态值
  data() {
    return {
      visible: false,
      rect: {},
      column: {},
      row: {},
      beforeRow: {},
      curValue: '',
      isEditTodo: false,
      isAppenPop: false,
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      allOrgList: [],
      seachText: '',
      isCustomDetail: false,
      customDetailValue: {},
      doubleConfirmation: false,
      pivotConfig: null,
      isName: false
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    goSearchOrg(e) {
      if (e.keyCode === 13 && this.doubleConfirmation) {
        let ref = null
        let type = ''
        if (this.column.type === 'roule') {
          ref = this.$refs.roleRef
          type = 'role'
        } else if (this.column.type === 'organization') {
          ref = this.$refs.organizeRef
          type = 'organization'
        }
        const checkList = ref.treeData
        if (checkList.length === 0) { 
          this.doubleConfirmation = false
        } else {
          this.changeCheck([checkList[0]], type)
          this.close()
        }
      } else if (e.keyCode === 13 && !this.doubleConfirmation) {
        this.$refs.organizeRef.fromParentSearch(this.seachText)
        this.isAppenPop = true
        this.doubleConfirmation = true
      } else {
        this.doubleConfirmation = false
      }
    },
    objSels (item) {
      if (typeof (item) === 'string') {
        return JSON.parse(item)
      } else {
        return item
      }
    },
    beforeFileUpload(file) {
      // 限制上传
      console.log(file,'filefilefile');
      
      const isLt2M = file.size / 1024 / 1024 < Number(this.column.maxSize);
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return isLt2M
    },
    beforeImgUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG && !isGIF) {
        this.$message.error("上传图片只能是 jpeg/png/gif 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M) || (isGIF && isLt2M);
    },
    uploadSuccess(file) {
      const response = filesConfig(file)
      if (!response) return
      let val = isJSON(this.row[this.column[this.rowKey]])
      val.push({ response })
      this.curValue = val
      this.row[this.column[this.rowKey]] = val
      this.isEditValue()
    },
    filesConfig() {
      return filesConfig()
    },
    delUpload(idx) {
      let val = isJSON(this.row[this.column[this.rowKey]])
      val.splice(idx, 1)
      this.row[this.column[this.rowKey]] = val
      this.curValue = JSON.stringify(val)
      this.isEditValue()
    },
    strImgAndFileData(val) {
      if (!val) return ''
      let filename = ''
      if (typeof val === 'object') {
        filename = val.realname || val.response || ''
      } else {
        filename = val
      }
      if (!filename) return ''
      try {
        const mps = filename.split('/')
        const mp = mps[mps.length - 1]
        const str = mp.split('-')[1]
        return str || filename
      } catch (err) {
        return filename
      }
    },
    changeCheck(val, type = 'organization') {
      let list = []
      if (type === 'organization') {
        list = formatOrg(val)
      } else {
        list = formatRole(val)
      }
      this.row[this.column[this.rowKey]] = list
      this.curValue = list
      if (type === 'organization') {
        this.seachText = list.map(item => getOrgShowName(item)).join(',')
      }
      this.isEditValue()
    },
    open (opt = {}) {
      const { row, column, rect, isCustomDetail, customDetailValue, pivotConfig, isName } = opt
      this.row = row
      this.beforeRow = cloneDeep(row)
      this.column = column
      this.visible = true
      this.isCustomDetail = isCustomDetail
      this.customDetailValue = customDetailValue
      if (pivotConfig) {
        this.pivotConfig = pivotConfig
      }
      this.isName = isName
      const rowRect = {}
      for (const key in rect) {
        if (['height', 'width', 'left', 'top'].includes(key)) { 
          rowRect[key] = rect[key] + 'px'
        }
      }
      this.rect = rowRect
      this.$nextTick(() => {
        if (!this.appendToBody) {
          document.body.addEventListener('click', this.close)
        }
        if (this.isTextAndTextarea) {
          this.$refs.textInp.focus()
        } else if (this.$refs.todoSelect) {
          this.$refs.todoSelect.focus()
          this.$refs.todoSelect.toggleMenu()
        } else if (this.$refs.todoDate) {
          this.$refs.todoDate.focus()
          this.$refs.todoDate.handleOpen()
        } else if (this.$refs.todoNumber) {
          setTimeout(() => {
            this.$refs.todoNumber.focus()
          }, 100);
        } else if (this.$refs.orgInput) {
          setTimeout(() => {
            this.$refs.orgInput.focus()
          }, 100);
        }
        if (this.isOrgAndRole) {
          // 角色控件和组织控件
          let ref = this.$refs.organizeRef
          let options = {}
          let type = 'JsonDataOrg'
          const opt = {
            id: this.approvalId,
            data: column,
          }
          if (column.type === 'organization') {
            ref = this.$refs.organizeRef
            const li = formatOrg(this.getValue)
            opt.info = li
            options.checkedArr = []
          } else if (column.type === 'roule') {
            ref = this.$refs.roleRef
            const li = formatRole(this.getValue)
            opt.info = li
            options.checkedArr = li
            type = 'JsonDataRole'
            options.isdoorMultiple = false
          }
          const param = getUserParam(opt)
          options = { ...options, apiurl: param.apiurl, onlyUser: param.onlyUser, option: param.lookCustomArr, leaf: param.leafOrg, radio: param.radio_, isLook: param.isLook, orgLabel: this.column.orgLabel, lookRMSIsOrg: this.column.lookRMSIsOrg }
          ref.fromParent(param[type], options)
          this.seachText = this.getOrgShowName
          this.isAppenPop = true
        }
      })
    },
    close() {
      if (this.isEditTodo) {
        if (this.isCustomDetail) {
          let details = this.row[this.customDetailValue.parent.parentDetail]
          const [title, option] = this.customDetailValue.parent.title.split('_')
          const [type] = this.customDetailValue.parent.type.split('_')
          details = typeof details === 'string' ? JSON.parse(details) : details
          for (const ele of details) {
            if (ele[`${title}_${type}`] === option) {
              ele[`${this.customDetailValue.title}_${this.customDetailValue.type}`] = this.curValue
            }
          }
          this.row[this.customDetailValue.parent.parentDetail] = JSON.stringify(details)
          this.$emit('change', {
            row: this.row,
            column: { title: this.customDetailValue.parent.parentDetail, type: 'details' },
            value: JSON.stringify(details)
          })
        } else if (this.pivotConfig) {
          this.$emit('change', {
            row: this.row,
            column: this.column,
            value: this.getValue,
            pivotConfig: this.pivotConfig
          })
        } else {
          this.$emit('change', {
            row: this.row,
            column: this.column,
            value: this.curValue
          })
        }
      } else {
        this.$emit('reset', { row: this.row, newValue: this.curValue })
      }
      this.visible = false
      this.isEditTodo = false
      this.curValue = ''
      this.isAppenPop = false
      this.$emit('close')
    },
    enterCheck(e) {
      if (this.column.type === 'textarea') {
        if (!e.ctrlKey && !e.shiftKey) {
          e.preventDefault()
          this.changeValue(this.getValue)
          this.close()
        }
      } else {
        e.preventDefault()
        this.changeValue(this.getValue)
        this.close()
      }
    },
    controlEnterCheck(val) {
      if (this.column.type === 'textarea') {
        let value = this.getValue
        val.preventDefault();
        // 获取当前光标位置
        const start = val.target.selectionStart
        const end = val.target.selectionEnd
        // 在光标位置插入换行符
        this.row[this.column[this.rowKey]] = value.substring(0, start) + '\n' + value.substring(end)
        this.$nextTick(() => {
          val.target.selectionStart = val.target.selectionEnd = start + 1
        })
      }
    },
    isEditValue() {
      const item = this.column
      if (this.pivotConfig) {
        if(this.beforeRow[this.pivotConfig.rowLabel] === this.getValue) return
      } else {
        // 判断是否有改动到值
        if (isObject(this.beforeRow[item.title])) {
          // 判断对象是否相等
          if (isEqual(this.beforeRow[item.title], this.getValue)) return
        } else if (this.column.type === 'number') {
          if (Number(this.beforeRow[item.title]) === Number(this.getValue)) return
        } else {
          if (this.beforeRow[item.title] === this.getValue) return
        }
      }
      this.isEditTodo = true
    },
    changeValue(val) {
      const item = this.column
      const row = this.row
      if (this.isCustomDetail) {
        const value = row[this.customDetailValue.parent.title]
        for (const ele of value) {
          if (ele.title === this.customDetailValue.title) {
            ele.value = val
            this.customDetailValue.value = val
          }
        }
        row[item.title] = value
      } else if (this.pivotConfig) {
        row[this.pivotConfig.rowLabel] = val
        this.pivotConfig.value = val
      } else {
        if (this.isTextAndTextarea) {
          if (val && val.target) {
            this.curValue = val.target.value
          }
        } else if (item.type === 'new-rel-radio') {
          this.curValue = val['自定义标题']
        } else if (item.type === 'date' && item.match === 'HH:mm' && val === '') {
          return
        }
        if (val === null) val = ''
        row[item[this.rowKey]] = val
      }
      this.curValue = val
      this.isEditValue()
    },
    isWYFN (val) {
      return isWY(val)
    },
    changeNumValue(val) {
      let value = val
      
      if (this.isWYFN(this.column)) {
        value = val * 10000
      }
      this.changeValue(value)
    },
    getSwitchColor (opt = {}) {
      return getSwitchColor(opt)
    },
    pickerOptionsLimit(val) {
      let date = val.dayWeek;
      if (
        !val.dayWeek &&
        (val.limit === "week" ||
          val.limit === "nextWeek" ||
          val.limit === "dayWeek")
      )
        date = 7;
      return limitDate(val.limit || "", date);
    },
    // 不包含本日的时间返回可选的开始时间
    nextMonthFun(val) {
      return thisNoTime(val);
    },
    isJSON(val) {
      return isJSON(val)
    }
  },
  computed: {
    getValue() {
      if (!this.column.type) return
      if (this.isCustomDetail) {
        return this.customDetailValue.value
      }
      if (this.pivotConfig) {
        return this.pivotConfig.value
      }
      if (this.isTextAndTextarea || this.isRadio || this.isDate) {
        return this.row[this.column[this.rowKey]]
      } else if (this.isNumber) {
        if (this.isWYFN(this.column)) {
          return Number(this.row[this.column[this.rowKey]]) / 10000
        } else {
          return Number(this.row[this.column[this.rowKey]])
        }
      } else if (this.isCheckBox) {
        let value = this.row[this.column[this.rowKey]]
        if (Array.isArray(value)) {
          return value
        } else if (value) {
          return value.split(',')
        } else {
          return []
        }
      } else if (this.isNewRelRadio) {
        return this.row['自定义标题']
      } else if (this.isOrgAndRole || this.isFile || this.isImage) {
        return isJSON(this.row[this.column[this.rowKey]]) || []
      } else {
        return ''
      }
    },
    rowKey() {
      if (this.isName) {
        return 'name'
      } else {
        return 'title'
      }
    },
    getOrgShowName() {
      if (this.isOrgAndRole) {
        if (this.column.type === 'organization') {
          return this.getValue.map(getOrgShowName).join(',')
        }
        const val = this.getValue.map(item => item.name || item.realname).join(',')
        return val
      } else {
        return ''
      }
    },
    getOrgAndRoleConfig() {
      if (this.isOrgAndRole) {
        const info = {
          id: this.approvalId,
          info: this.getValue,
          data: this.column
        }
        const param = getUserParam(info)
        return param
      } else {
        return {}
      }
    },
    isTextAndTextarea() {
      return ['text', 'textarea'].includes(this.column.type)
    },
    isNumber() {
      return this.column.type === 'number'
    },
    isRadio() {
      return this.column.type === 'radio'
    },
    isCheckBox() {
      return this.column.type === 'checkbox'
    },
    isDate() {
      return this.column.type === 'date'
    },
    isOrgAndRole() {
      return ['organization','roule'].indexOf(this.column.type) !== -1
    },
    isNewRelRadio() {
      return this.column.type === 'new-rel-radio'
    },
    isFile() {
      return this.column.type === 'file'
    },
    isImage() {
      return  this.column.type === 'image'
    }
  }
}
</script>

<style scoped lang="scss">
$defaultHeight: var(--default-height);

.todo-edit {
  position: absolute;
  width: 100vw;
  height: 100vh;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.5);
  &-content {
    position: absolute;
    background-color: #fff;
    min-height: 32px;
    min-width: 180px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    padding: 4px;
    box-sizing: border-box;
    z-index: 2;
    min-height: 32px;
    display: flex;
  }
}
.todo-edit-on, .todo-edit {
  ::v-deep .el-textarea {
    height: 100%;
    .el-textarea__inner {
      height: 100%;
    }
  }
  
  .img-file {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    padding-right: 36px;
    box-sizing: border-box;
    .todo-upload {
      width: 28px;
      height: 28px;
      border: solid 1px #DCDFE6;
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .icon-wenjianfujian {
      color: #999999;
      font-size: 14px;
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      height: 26px;
    }
    &-style {
      margin-left: 20px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-bottom: 10px;
      .el-icon-delete {
        color: #e47470;
        cursor: pointer;
        margin-left: 5px;
      }
      .img-file-content {
        cursor: pointer;
        padding-right: 5px;
        color: #4e86ff;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 14px;
        // flex: 1;
        &:hover {
          text-decoration: underline;
        }
      }
      .img-file-icon {
        cursor: pointer;
        .icon-xiazai2x {
          font-size: 14px;
          color: #4e86ff;
        }
      }
    }
  }
  
  ::v-deep .el-select {
    height: $defaultHeight;
    line-height: $defaultHeight;
    .el-select__wrapper {
      height: $defaultHeight;
      min-height: $defaultHeight;
    }
    .el-input {
      height: $defaultHeight;
      line-height: $defaultHeight;
      .el-input__inner {
        height: 100%;
        line-height: $defaultHeight;
      }
    }
  
    .el-input__icon {
      line-height: $defaultHeight;
    }
  }
  
  ::v-deep .el-input {
    height: $defaultHeight;
    line-height: $defaultHeight;
    .el-input__inner {
      height: $defaultHeight;
      line-height: $defaultHeight;
    }
  }
  
  .list-app-img {
    display: flex;
    position: relative;
    flex-wrap: wrap;
    padding-right: 36px;
    box-sizing: border-box;
    min-height: 32px;
    &-item {
      display: flex;
      align-items: center;
      margin-left: 5px;
      width: 28px;
      height: 28px;
      position: relative;
      overflow: hidden;
      .img-mask {
        transition: .3s;
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.48);
        left: 0;
        top: 0;
        transform: translateX(-100%);
        .el-icon-delete {
          font-size: 12px;
          cursor: pointer;
          color: #fff;
        }
      }
      &:hover {
        .img-mask {
          transform: translateX(0);
        }
      }
    }
    .todo-img {
      position: relative;
      overflow: hidden;
    }
    .todo-upload {
      width: 28px;
      height: 28px;
      border: solid 1px #DCDFE6;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: auto;
      cursor: pointer;
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>

<style lang="scss">
.role-organize-content {
  max-height: 400px;
  overflow-y: auto;
  .el-scrollbar {
    min-height: 25px;
  }
}
</style>